import { z } from 'zod';
export const expenseCategorySchema = z.lazy(() => z.object({
    id: z.number(),
    name: z.string(),
    slug: z.string(),
    parentId: z.number().nullable(),
    projectType: z.string().nullable(),
    icon: z.string().nullable(),
    color: z.string().nullable(),
    order: z.number(),
    isSystem: z.boolean(),
    children: z.array(expenseCategorySchema).optional(),
}));
//# sourceMappingURL=expense-category.js.map